const validarExpresion = (tipo, expresion) => {
  let valido = true;
  switch (tipo) {
    case "rut":
      valido = /^(\d{0,3}\.\d{3}\.\d{3}-(\d|K|k))|(\d{6,9}-?(\d|k|K))|(\d{3}\.\d{3}-(\d|K|k))$/.test(
        expresion
      );
      break;

    case "correo":
      valido = /^([A-Z|a-z|0-9](\.|_){0,1})+[A-Z|a-z|0-9]\@([A-Z|a-z|0-9])+((\.){0,1}[A-Z|a-z|0-9]){2}\.[A-Z|a-z]{2,3}$/.test(
        expresion
      );
      break;

    case "telefono":
      valido = /^((\d{9,})|(\d{8})|(\d{1}\s\d{3}\s\d{2}\s?\d{2})|(\d{1}\s\d{7}))$/.test(
        expresion
      );
      break;

    case "telefono-longitud":
      valido = /^(\d{9,})$/.test(expresion);
      break;

    case "serie":
      valido = /^([A-Za-z0-9]{3})\.([0-9]{3})\.([0-9]{3})$/.test(expresion);
      break;

    case "password":
      valido = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,16}$/.test(
        expresion
      );
      break;

    case "fecha":
      if (/^(\d{2})(\/\d{2}\/|-\d{2}-)(\d{4})$/.test(expresion)) {
        let t = expresion.split(expresion.charAt(2));
        let d = +t[0],
          m = +t[1] - 1,
          y = +t[2];
        let date = new Date(y, m, d);
        if (date.getFullYear() === y && date.getMonth() === m) {
          valido = true;
        } else {
          valido = false;
        }
      } else {
        valido = false;
      }
      break;

    default:
      break;
  }
  return valido;
};

export default {
  validarExpresion
};



// WEBPACK FOOTER //
// ./src/assets/js/validador.js